import { createFileRoute } from '@tanstack/react-router';
import { SemanticModelDraftReviewPage } from '@/features/metric-hub/semantic-models/SemanticModelDraftReviewPage';

/**
 * Semantic-model draft review (read mode).
 *
 * `$name_` opts out of the `$name` detail layout, like the sibling `.edit`
 * leaf. Every model-draft notification (decision, comment, mention, reminder,
 * the weekly digest) links here; before this route existed they landed on
 * Not Found, and the inbox pointed at a `#draft-…` anchor the detail page
 * never rendered.
 *
 * URL: `/metric-hub/semantic-models/<name>/drafts/<draftId>`.
 */
export const Route = createFileRoute('/_authed/metric-hub/semantic-models/$name_/drafts/$draftId/')(
  {
    component: SemanticModelDraftRoute,
  },
);

function SemanticModelDraftRoute() {
  const { name, draftId } = Route.useParams();
  return <SemanticModelDraftReviewPage name={name} draftId={draftId} />;
}
